<template>
  <div class="container page service-page">
    <van-nav-bar :title="$t('kefu.title')" class="service-page__nav">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="service-page__frame-wrap">
      <iframe
        v-if="iframeSrc"
        id="iframe_web"
        class="service-page__iframe"
        width="100%"
        height="100%"
        frameborder="0"
        :src="iframeSrc"
      />
    </div>
  </div>
</template>

<script>
function appendVisitorParams(url, visiterId, visiterName) {
  if (!url) return url;
  const parts = url.split('#');
  const main = parts[0];
  const hash = parts.length > 1 ? parts.slice(1).join('#') : '';
  const qs = new URLSearchParams();
  if (visiterId !== undefined && visiterId !== null && String(visiterId) !== '') {
    qs.set('visiter_id', String(visiterId));
  }
  if (visiterName !== undefined && visiterName !== null && String(visiterName) !== '') {
    qs.set('visiter_name', String(visiterName));
  }
  const query = qs.toString();
  if (!query) {
    return hash ? `${main}#${hash}` : url;
  }
  const sep = main.includes('?') ? '&' : '?';
  const nextMain = `${main}${sep}${query}`;
  return hash ? `${nextMain}#${hash}` : nextMain;
}

export default {
  data() {
    return {
      iframeSrc: '',
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    defaultKefu() {
      const k = this.$store.getters.getBaseInfo.kefu;
      return k !== undefined && k !== null && String(k) !== '' ? String(k) : 'https://hao.360.com/';
    },
    async resolveIframeSrc() {
      const base = this.defaultKefu();
      let visiterId = localStorage.getItem('token') || '';
      let visiterName = '';
      if (visiterId) {
        try {
          const res = await this.$http({
            method: 'get',
            url: 'user_info',
          });
          if (res.code === 200 && res.data) {
            if (res.data.id !== undefined && res.data.id !== null && String(res.data.id) !== '') {
              visiterId = String(res.data.id);
            }
            if (res.data.username !== undefined && res.data.username !== null && String(res.data.username) !== '') {
              visiterName = String(res.data.username);
            }
          }
        } catch (e) {
          // 仍使用 localStorage 中的 userid 作为 visiter_id
        }
      }
      this.iframeSrc = appendVisitorParams(base, visiterId, visiterName);
    },
  },
  created() {
    this.resolveIframeSrc();
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

/* 整页占满视口，避免 iframe 与标题把页面撑出屏幕 */
.service-page.container.page {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  max-width: 100%;
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.service-page__nav {
  z-index: 999;
  position: relative;
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  background: url(/img/header.svg) no-repeat 50% / 100%;
  &::v-deep .van-nav-bar__title {
    max-width: 62%;
    margin: 0 auto;
    padding: 0 8px;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.2;
    font-size: 32px;
  }
  &::v-deep .van-nav-bar__content {
    max-width: 100%;
  }
}

.service-page__frame-wrap {
  flex: 1;
  min-height: 0;
  width: 100%;
  max-width: 100%;
  position: relative;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.service-page__iframe {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  max-width: 100%;
  height: 100%;
  border: 0;
  display: block;
  box-sizing: border-box;
}
</style>
